import {Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {ToastListComponent} from './core/components/toast-list/toast-list.component';
import {FooterComponent} from './shared/layout/footer/footer.component';
import {NavigationBarComponent} from './shared/layout/navigation-bar/navigation-bar.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  imports: [
    NavigationBarComponent,
    RouterOutlet,
    FooterComponent,
    ToastListComponent,
  ],
})
export class AppComponent {
}
